export const lowercaseCount = (str: string) => {
  return str.length - str.replace(/[a-z]/g, '').length;
};

export const uppercaseCount = (str: string) => {
  return str.length - str.replace(/[A-Z]/g, '').length;
};

export const numbersCount = (str: string) => {
  return str.replace(/[^0-9]/g, '').length;
};

export const specialCharsCount = (str: string) => {
  return (str.match(/[`~!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g) || []).length;
};

export const matchLength = (str: string, length: number) => {
  const error: any = {};
  if (str.length !== length) {
    error.length = true;
  }
  return Object.keys(error).length !== 0 ? error : null;
};

export const notEmpty = (str: string) => {
  const error: any = {};
  if (str.length === 0) {
    error.length = true;
  }
  return Object.keys(error).length !== 0 ? error : null;
};

export const minChar = (str: string, minLength: number) => {
  const error: any = {};
  if (str.length < minLength) {
    error.length = true;
  }
  return Object.keys(error).length !== 0 ? error : null;
};
